import theme from '../../../constants/theme';
const COLORSET = [theme.primaryColor, theme.primaryColorLight];

const fallback = (value, fallback) => (value ? value : fallback);

const joinObjects = (obj1, obj2) => Object.assign(fallback(obj1, {}), fallback(obj2, {}));

const getBarColor = (color, barIndex) => {
  if (color) return color;
  return COLORSET[barIndex % COLORSET.length];
};

const isLabelVisible = height => height > 28;

const isDataNotEmpty = (data, yAxisId) =>
  data.sets && data.sets[yAxisId] && data.sets[yAxisId].data && data.sets[yAxisId].data.length > 0;

const isYAxisNotEmpty = (data, yAxisId) => data.sets && data.sets[yAxisId] && data.sets[yAxisId].yLabel;

export {fallback, joinObjects, getBarColor, isLabelVisible, isDataNotEmpty, isYAxisNotEmpty};
